/* (c) Copyright Frontify Ltd., all rights reserved. */

import { MarkupElement } from '../../MarkupElement';

export class AlignLeftMarkupElement extends MarkupElement {
    constructor(id = 'align-left') {
        super(id);
    }
}
